import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type DynamicPricingStatusType = 'SCHEDULED' | 'ONGOING' | 'CANCELLED' | 'DONE'

export type DynamicPricingQueryType = {
  id?: string
  name?: string
  from?: string
  to?: string
  order_by?: string
  order_direction?: string
  page_size?: string
  cursor?: string
}

export type DynamicPricingType = {
  id: number
  name: string
  start_time: string
  end_time: string
  status: DynamicPricingStatusType
  total_sku: number
  duration: string
}

export type DynamicPricingPaginationType = {
  prev_cursor: string
  next_cursor: string
}

export type GetDynamicPricingResponseType = {
  data: DynamicPricingType[]
  pagination: DynamicPricingPaginationType
}

export type DynamicPricingDetailType = DynamicPricingType & {
  locations: string[]
  created_by: string
  created_at: string
  updated_by: string
  updated_at: string
  file_url: string
}

export type DynamicPricePayloadType = {
  name: string
  start_time: string
  end_time: string
}

export const getDynamicPricingAPI = (params: DynamicPricingQueryType) =>
  axiosInstanceApiGateway.Get<GetDynamicPricingResponseType, true>({
    url: 'pricing-engine/internal/:version/dynamic-prices',
    version: 'v1',
    params,
  })

export const getDynamincPricingDetailAPI = (id: number) =>
  axiosInstanceApiGateway.Get<{ data: DynamicPricingDetailType }, true>({
    url: 'pricing-engine/internal/:version/dynamic-prices/:id',
    version: 'v1',
    urlParams: { id },
  })

export const postDynamicPricingAPI = (data: DynamicPricePayloadType) =>
  axiosInstanceApiGateway.Post({
    url: 'pricing-engine/internal/:version/dynamic-prices',
    version: 'v1',
    data,
  })

export const putDynamicPricingAPI = (id: number, data: DynamicPricePayloadType) =>
  axiosInstanceApiGateway.Put<{
    data: DynamicPricingType
  }>({
    url: 'pricing-engine/internal/:version/dynamic-prices/:id',
    version: 'v1',
    data,
    urlParams: { id },
  })

export const cancelDynamicPricingAPI = (id: number) =>
  axiosInstanceApiGateway.Put<{
    data: DynamicPricingType
  }>({
    url: 'pricing-engine/internal/:version/dynamic-prices/:id/cancel',
    version: 'v1',
    urlParams: { id },
  })

export const downloadDynamincPriceAPI = (id: number) =>
  axiosInstanceApiGateway.Get<{ data: { file_url: string; message: string } }, true>({
    url: 'pricing-engine/internal/:version/dynamic-prices/:id/download',
    version: 'v1',
    urlParams: { id },
  })
